export const validatorInn = () => ({
  validator(_: string, value: number) {
    if (String(value).length === 10 || String(value).length === 12) {
      return Promise.resolve();
    }
    return Promise.reject('ИНН введен некорректно');
  }
});
